import ControlViewModel from '@/ViewModels/ControlViewModel';
import ComponentManager from '@/Management/ComponentManager';
import LabelViewModel from '@/ViewModels/Controls/LabelViewModel';
import PrincipalHistorizationPreviewItemViewModel from '@/ViewModels/Controls/PrincipalHistorizationPreviewItemViewModel';

export default class PrincipalHistorizationPreviewViewModel extends ControlViewModel {

    private LabelViewModel = ComponentManager.getViewModel<typeof LabelViewModel>('LabelViewModel');

    /**
     * Beinhaltet die selektierbaren Werte
     */
    public items: KnockoutObservable<PrincipalHistorizationPreviewItemViewModel[]>;

    /**
     * Die Überschrift
     */
    public label: LabelViewModel;

    /**
     * Das ViewModel für den PrincipalHistorizationPreview
     * @param {object} params - Ein Objekt mit Optionen für das Control
     * @constructor
     */
    public constructor(params: any) {
        super(params);

        this.items = this.observableOrDefault(params.items, []);
        this.label =  new this.LabelViewModel({
            parentLocator: this.locator,
            locator: 'label',
            ergName: 'HISTORIZED_PRINCIPALS'
        });
    }
}

ComponentManager.setViewModel('PrincipalHistorizationPreviewViewModel', PrincipalHistorizationPreviewViewModel, 'RADPresentation.HTMLClient.DefaultViewExtensions');